import Tooltip from '@mui/material/Tooltip';
import { withStyles } from '@mui/styles';

export const DarkArrowTooltip = withStyles(() => ({
    tooltip: {
        backgroundColor: 'black',
        color: 'white',
        fontFamily: 'Nunito Sans',
        fontWeight: 400,
        fontSize: '13px',
        lineHeight: '18px'
    },

    arrow: {
        color: 'black',
    },
}))(Tooltip);




